"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
const antd_1 = require("antd");
Object.defineProperty(exports, "Carousel", { enumerable: true, get: function () { return antd_1.Carousel; } });
